import { render, staticRenderFns } from "./ManterBancoMateriaisPelosFormadoresView.vue?vue&type=template&id=573c559c"
import script from "./ManterBancoMateriaisPelosFormadoresView.vue?vue&type=script&lang=js"
export * from "./ManterBancoMateriaisPelosFormadoresView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports